import { useContext } from 'react'
import { useMediaQuery } from 'usehooks-ts'
import { ThemeContext } from '@/src/contexts'

import { Typography, theme } from 'antd'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

const { Title } = Typography

type PhysiciansCounterProps = {
  total: number
  loading: boolean
  results: any
}

export const PhysiciansCounter = ({
  total,
  loading,
  results,
}: PhysiciansCounterProps) => {
  const { isDarkMode } = useContext(ThemeContext)
  const isLargeScreen = useMediaQuery('(min-width: 1024px)')

  const {
    token: { colorTextTertiary },
  } = theme.useToken()

  const isLoading = loading || !results
  const titleLevel = isLargeScreen ? 4 : 5

  const commonTitleStyles = {
    margin: 0,
    display: 'inline',
    color: isDarkMode ? '#38A7C8' : '#274765',
  }

  return (
    <>
      <FontAwesomeIcon
        icon='user-doctor'
        className={`inline mr-2 text-xl ${isLoading ? 'animate-pulse' : ''}`}
        style={{ color: colorTextTertiary }}
      />
      {isLoading ? (
        <Title
          level={titleLevel}
          style={{
            ...commonTitleStyles,
            fontWeight: 500,
          }}
          className='animate-pulse'
        >
          Loading Physicians...
        </Title>
      ) : (
        <div className='inline'>
          <Title
            level={titleLevel}
            style={{
              ...commonTitleStyles,
              marginRight: 8,
              fontWeight: 900,
            }}
          >
            {total}
          </Title>
          <Title
            level={titleLevel}
            style={{
              ...commonTitleStyles,
              fontWeight: 500,
            }}
          >
            {total === 1 ? 'Physician found' : 'Physicians found'}
          </Title>
        </div>
      )}
    </>
  )
}
